import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import VerifyEmailBanner from '../components/VerifyEmailBanner';
import { ArrowRight, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_5935cf64-512e-4adb-972b-b8d08d999032/artifacts/9m3z1jc8_thumbnail_PHOTO-2025-02-05-22-08-51.jpg';

const Welcome = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-amber-600" />
      </div>
    );
  }
  if (!user) {
    navigate('/signup', { replace: true });
    return null;
  }

  const skip = () => {
    toast('Search coming soon', {
      description: "We’re still wiring up listings. We’ll take you back home for now.",
    });
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="welcome-page">
      <VerifyEmailBanner />
      <main className="flex-1 px-5 pt-10 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-md mx-auto text-center"
        >
          <img src={LOGO_URL} alt="Sturent" className="h-14 w-14 rounded-2xl object-cover shadow-sm mx-auto mb-6" />
          <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-slate-900 leading-tight">
            Welcome to Sturent, {user.first_name}.
          </h1>
          <p className="mt-3 text-base text-slate-600 leading-relaxed">
            Let’s find you a home. A few quick questions will help us show you the best places.
          </p>

          <div className="mt-8 space-y-3">
            <Button
              className="w-full h-12 btn-primary text-base"
              onClick={() => navigate('/onboarding/school')}
              data-testid="welcome-start-btn"
            >
              Let’s go
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <button
              onClick={skip}
              className="w-full text-sm text-slate-600 hover:text-slate-900 py-2"
              data-testid="welcome-skip-link"
            >
              Skip for now
            </button>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default Welcome;
